import { useContext, useState } from 'react';
import Dialog from '@/components/Dialog';
import { IconButton } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import useApi from '@/lib/api/useApi';
import { type EditorLevel } from '@/lib/types';
import EditorPortfolioTemplatesContext from '../../EditorPortfolioTemplatesContext';

type DeleteLevelProps = {
  level: EditorLevel;
};

const DeleteLevel = ({ level }: DeleteLevelProps) => {
  const api = useApi();

  const [, setPortfolioTemplates] = useContext(EditorPortfolioTemplatesContext);

  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const deleteLevel = async (): Promise<void> => {
    setConfirmationDialogOpen(false);
    setDeleting(true);

    await api.delete(`editor/portfolio-templates/levels/${level.id}`);

    setPortfolioTemplates(portfolioTemplates => {
      delete portfolioTemplates.levels[level.id];
    });

    setDeleting(false);
  };

  return (
    <>
      <IconButton
        onClick={() => setConfirmationDialogOpen(true)}
        disabled={deleting}
      >
        <DeleteIcon />
      </IconButton>
      <Dialog
        open={confirmationDialogOpen}
        onClose={() => setConfirmationDialogOpen(false)}
        dangerous
      >
        <Dialog.Title>
          <FormattedMessage id="portfolio_template_editor.level.delete.title" />
        </Dialog.Title>
        <Dialog.Content>
          <Dialog.ContentText>
            <FormattedMessage id="portfolio_template_editor.level.delete.text" />
          </Dialog.ContentText>
        </Dialog.Content>
        <Dialog.Actions>
          <Dialog.Actions.CancelButton
            onClick={() => setConfirmationDialogOpen(false)}
          />
          <Dialog.Actions.DeleteButton onClick={deleteLevel} />
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default DeleteLevel;
